import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  // ssid:{ssid: '', psk: '', updatetime: ''}
};
class WifiPwdRecord extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("wifiPwd.json"), DEFAULTSET);
  }
  getWifiPwd() {
    return this.getSettings();
  }
  saveWifiPWdSettings(settings) {
    super.saveSettings(settings);
  }

  static init() {
    this.wifi = this.wifi || new WifiPwdRecord();
    return this.wifi;
  }
}
export default WifiPwdRecord.init();



// WEBPACK FOOTER //
// ./src/settings/wifiPwdRecord.js